import type { FC } from 'react';
import { memo } from 'react';

import { Header, Modal } from '@procurify/ui'
import { useIntl } from 'react-intl'

import messages from './messages'
import {
  type ISavedFiltersFormProps,
  SavedFiltersForm,
} from './SavedFiltersForm'

export interface ISavedFiltersFormModalProps extends ISavedFiltersFormProps {
  open?: boolean
  onDismiss?: () => void
}

export const SavedFiltersFormModal: FC<ISavedFiltersFormModalProps> =
  memo((props) => {
    const { open, onDismiss, ...formProps } = props

    const intl = useIntl()

    return (
      <Modal maxWidth='sm' open={open} onClose={onDismiss}>
        <Modal.Card>
          <Modal.Header onClose={onDismiss}>
            {intl.formatMessage(messages.modalTitle)}
          </Modal.Header>
          <Modal.Content>
            <SavedFiltersForm onCancel={onDismiss} {...formProps} />
          </Modal.Content>
        </Modal.Card>
      </Modal>
    )
  })

SavedFiltersFormModal.defaultProps = {
  onDismiss: () => undefined,
}
SavedFiltersFormModal.displayName = 'SavedFiltersFormModal'
